<template>
    <v-card flat tile height="100%" class="d-flex flex-column" v-if="$store.state.chat.currentChat">
      <v-card-text class="flex-grow-1 overflow-y-auto" ref="messageContainer">
        <div
          v-for="message in $store.getters['chat/getCurrentChatMessages']"
          :key="message.id"
          :class="['message', message.sender === 'You' ? 'sent' : 'received']"
        >
          <div class="message-content">{{ message.content }}</div>
          <div class="message-timestamp">{{ message.timestamp }}</div>
        </div>
      </v-card-text>
      <v-card-actions class="pa-2">
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on">
              <v-icon>mdi-paperclip</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item @click="() => {}">
              <v-list-item-icon>
                <v-icon>mdi-camera</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Camera</v-list-item-title>
            </v-list-item>
            <v-list-item @click="() => {}">
              <v-list-item-icon>
                <v-icon>mdi-image</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Gallery</v-list-item-title>
            </v-list-item>
            <v-list-item @click="() => {}">
              <v-list-item-icon>
                <v-icon>mdi-file-document</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Document</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-text-field
          v-model="newMessage"
          placeholder="Type a message"
          append-outer-icon="mdi-send"
          @click:append-outer="sendMessage"
          @keyup.enter="sendMessage"
          hide-details
          outlined
          dense
          class="mx-2"
        ></v-text-field>
        <v-btn icon @click="sendVoiceMessage">
          <v-icon>mdi-microphone</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-layout v-else align-center justify-center fill-height>
      <v-card-text>Select a chat to start messaging</v-card-text>
    </v-layout>
  </template>
  
  <script>
  export default {
    name: 'ChatMessages',
    data() {
      return {
        newMessage: ''
      };
    },
    methods: {
      sendMessage() {
        if (this.newMessage.trim()) {
          this.$store.dispatch('chat/sendMessage', {
            chatId: this.$store.state.chat.currentChat,
            content: this.newMessage.trim()
          });
          this.newMessage = '';
          this.$nextTick(() => {
            this.scrollToBottom();
          });
        }
      },
      sendVoiceMessage() {
        // Implement voice message functionality
        console.log('Voice message feature not implemented yet');
      },
      scrollToBottom() {
        const container = this.$refs.messageContainer;
        container.scrollTop = container.scrollHeight;
      }
    },
    updated() {
      this.scrollToBottom();
    }
  };
  </script>
  
  <style scoped>
  .message {
    max-width: 70%;
    margin-bottom: 8px;
    padding: 8px 12px;
    border-radius: 12px;
  }
  
  .sent {
    align-self: flex-end;
    background-color: #dcf8c6;
    margin-left: auto;
  }
  
  .received {
    align-self: flex-start;
    background-color: #ffffff;
  }
  
  .message-content {
    margin-bottom: 4px;
  }
  
  .message-timestamp {
    font-size: 0.75rem;
    color: #999;
    text-align: right;
  }
  </style>